@if (displayMode == TimelineDisplayMode.Horizontal || !multiViewsSupport) {
  <!-- pined timeline blocks -->
  @if (pinnedTimelines && pinnedTimelines.length) {
    <div class="pinned-timeline" #pinnedTimelineDiv [style.left]="'38px'">
      <div class="d-flex mt-3">
        @for (timeline of pinnedTimelines; track timeline) {
          <div
            class="pin-timeline-content-open"
            style="height: 99px"
            [ngClass]="timeline.removeBlock ? 'd-none' : ''"
            [style.background]="timeline.blockColor"
            [style.border]="`3px solid ${timeline.blockColor}`">
            @if (!timeline?.showBlock && timeline?.showToggleIcons) {
              <div class="d-flex" (click)="toggleBlockView(timeline); handlePinBlocks(null)">
                <img [alt]="'right-triangle'" ngSrc="/assets/img/project-v2/right-triangle-white.svg" alt="" fill="" />
                <img
                  class="ms-1"
                  [alt]="'left-triangle'"
                  ngSrc="/assets/img/project-v2/left-triangle-white.svg"
                  alt=""
                  fill="" />
              </div>
            }
            @if (timeline?.showBlock) {
              <div class="campaign-scroll-container ms-1">
                <div class="pin-div" (click)="handlePinBlocks(timeline)">
                  <i
                    class="fa fa-thumb-tack"
                    [ngClass]="timeline.pinBlock ? 'text-white rotate-pin' : ''"
                    style="font-size: 10px; color: #c4c4c4"
                    aria-hidden="true"></i>
                </div>
                @if (timeline?.showToggleIcons) {
                  <div
                    class="open-button"
                    [style.border-left-color]="timeline.blockColor"
                    (click)="toggleBlockView(timeline); handlePinBlocks(null)"
                    title="{{ 'collapse' | translate }}">
                    <i class="right-icon fa fa-caret-right fa-lg" [style.color]="timeline.blockColor"></i>
                  </div>
                }
                @if (timeline?.showToggleIcons) {
                  <div
                    class="close-button me-1"
                    [style.border-right-color]="timeline.blockColor"
                    (click)="toggleBlockView(timeline); handlePinBlocks(null)"
                    title="{{ 'collapse' | translate }}">
                    <i class="left-icon fa fa-caret-left fa-lg" [style.color]="timeline.blockColor"></i>
                  </div>
                }
                <div class="campaign-scroll me-1 wrap">
                  @for (milestone of timeline.items; track milestone; let i = $index) {
                    <div
                      class="milestone-item"
                      (click)="editMilestone(milestone)"
                      [ngClass]="{ 'disabled-milestone': milestone.activeMilestone == false }">
                      @if (!milestone.items) {
                        <div>
                          <div
                            class="milestone-header px-2"
                            style="position: relative"
                            [style.background]="timeline.blockColor">
                            <div class="pt-1">
                              <span class="timeline-mad-div-text">{{
                                milestone?.mad === 'MAD' ? 'DUE DATE' : milestone?.mad
                              }}</span>
                            </div>
                            <div class="pb-1">
                              <span class="timeline-mad-div-text">{{
                                getFormattedDate(milestone.driveDate) | ngbDate
                              }}</span>
                            </div>
                          </div>
                          @if (canEdit) {
                            <div class="timeline-name-div milestone-body" [style.background]="'#FFFFFF'">
                              <img
                                [alt]="'calendar'"
                                ngSrc="/assets/img/project-v2/calendar-black.svg"
                                width="12"
                                height="10"
                                class="calendar-icon" />
                              <span class="timeline-name-div-text">{{ milestone.name }}</span>
                            </div>
                          }
                        </div>
                      }
                      <!-- sub items -->
                      <!-- sub items campaign timeline -->
                      @if (timeline.name === 'CAMPAIGN' && milestone.items) {
                        <div
                          class="timeline-name-div-text d-flex d-flex justify-content-center bg-white text-black py-0"
                          style="position: relative; top: 30px; height: 14px; font-size: 35%"
                          >{{ milestone.name }}</div
                        >
                        <div class="d-flex" style="width: 100%">
                          @for (subItem of milestone.items; track subItem) {
                            <div (click)="editMilestone(subItem)">
                              <div
                                class=""
                                style="top: -14px; position: relative; height: 17px"
                                [style.background]="timeline.blockColor">
                                <div class="pt-1">
                                  <span class="timeline-mad-div-text">{{ subItem.mad }}</span>
                                </div>
                                <div class="pb-1">
                                  <span class="timeline-mad-div-text">{{
                                    getFormattedDate(subItem.driveDate) | ngbDate
                                  }}</span>
                                </div>
                              </div>
                              @if (canEdit) {
                                <div
                                  class="timeline-name-div"
                                  style="align-items: end"
                                  [style.background]="timeline.blockColor">
                                  <img
                                    [alt]="'calendar'"
                                    ngSrc="/assets/img/project-v2/calendar-black.svg"
                                    width="12"
                                    height="10"
                                    class="calendar-icon" />
                                  <span class="timeline-name-div-text text-white">{{ subItem.name }}</span>
                                </div>
                              }
                            </div>
                          }
                        </div>
                      }
                      <!-- sub items other timelines -->
                      @if (timeline.name !== 'CAMPAIGN' && milestone.items) {
                        <div class="d-flex" style="width: 212px">
                          @for (subItem of milestone.items; track subItem) {
                            <div class="col" [style.background]="timeline.blockColor" (click)="editMilestone(subItem)">
                              <div
                                class=""
                                style="position: relative; height: 35px"
                                [style.background]="timeline.blockColor">
                                <div class="d-flex justify-content-center">
                                  <span class="d-flex align-item-center _600 f-10 c-full-white">{{ subItem.mad }}</span>
                                </div>
                                <div class="d-flex justify-content-center">
                                  <span class="d-flex align-item-center _600 f-8 c-full-white">{{
                                    getFormattedDate(subItem.driveDate) | ngbDate
                                  }}</span>
                                </div>
                              </div>
                              <div class="row">
                                <div
                                  class="col border-right d-flex justify-content-center align-items-center"
                                  [style.max-width]="'100%'"
                                  [style.min-width]="'73px'"
                                  [style.background]="`linear-gradient(0deg, rgba(255, 255, 255, ${i * 0.2 + 0.2}), rgba(255, 255, 255, ${i * 0.2 + 0.2})), ${timeline.blockColor}`"
                                  [style.height]="'25px'">
                                  <span class="text-center d-flex align-item-center _600 f-7 c-full-white">{{
                                    subItem.name
                                  }}</span>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                        <div
                          class="col border-right d-flex justify-content-center"
                          [style.height]="'35px'"
                          [style.background]="'#fff'">
                          <div class="d-flex justify-content-center align-items-center">
                            <span class="d-flex align-item-center _600 f-9 c-mtm-full-black">{{ milestone.name }}</span>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
  <!-- timeline block -->
  @if (timelines && timelines.length) {
    <div class="timeline-card" style="width: 100%">
      <div class="d-flex mt-3 timeline-scroll" id="scroll-container" (scroll)="checkScrollState($event)">
        <!-- left-side button for scroll class="left-btn-gradiant"  -->
        <div
          id="scroll-left-button"
          [class.disabled]="!fixedTimelineSize && !isLeftArrowVisible"
          title="{{ 'scrollLeft' | translate }}">
          <div class="scroll-btn scroll-btn-left" (click)="scrollToLeft()">
            <img [alt]="'right-triangle'" ngSrc="/assets/img/project-v2/right-triangle-white.svg" alt="" fill="" />
          </div>
        </div>
        <div
          id="scroll-left-button"
          title="{{ 'scrollStart' | translate }}"
          [class.disabled]="!fixedTimelineSize && !isLeftArrowVisibleForFive">
          <div class="scroll-btn scroll-btn-left-fast-forward" (click)="scrollToLeft(425)">
            <img [alt]="'right-triangle'" ngSrc="/assets/img/project-v2/right-triangle-white.svg" alt="" fill="" />
            <img [alt]="'right-triangle'" ngSrc="/assets/img/project-v2/right-triangle-white.svg" alt="" fill="" />
          </div>
        </div>
        <!-- Milestone Blocks -->
        <div class="d-flex mx-0 Row" [style.padding-left]="`${pinnedTimelineDivWidthSize}px`">
          @for (timeline of timelines; track timeline) {
            <div
              class="timeline-content-open"
              [class.expand-bar]="!timeline?.showBlock && timeline?.showToggleIcons"
              [attr.title]="!timeline?.showBlock && timeline?.showToggleIcons ? ('expand' | translate) : null"
              [ngClass]="timeline?.removeBlock || timeline?.pinBlock ? 'd-none' : ''">
              @if (!timeline?.showBlock && timeline?.showToggleIcons) {
                <div class="d-flex" (click)="toggleBlockView(timeline)">
                  <img
                    [alt]="'right-triangle'"
                    ngSrc="/assets/img/project-v2/right-triangle-white.svg"
                    alt=""
                    fill="" />
                  <img
                    class="ms-1"
                    [alt]="'left-triangle'"
                    ngSrc="/assets/img/project-v2/left-triangle-white.svg"
                    alt=""
                    fill="" />
                </div>
              }
              @if (timeline?.showBlock && !timeline.pinBlock) {
                <div class="campaign-scroll-container">
                  @if (timeline?.showToggleIcons) {
                    <div class="pin-div" (click)="handlePinBlocks(timeline)">
                      <i
                        class="fa fa-thumb-tack"
                        [ngClass]="timeline.pinBlock ? 'text-white rotate-pin' : ''"
                        style="font-size: 10px; color: #c4c4c4"
                        aria-hidden="true"></i>
                    </div>
                  }
                  @if (timeline?.showToggleIcons) {
                    <div
                      class="open-button"
                      [style.border-left-color]="timeline.blockColor"
                      (click)="toggleBlockView(timeline)"
                      title="{{ 'collapse' | translate }}">
                      <i class="right-icon fa fa-caret-right fa-lg" [style.color]="timeline.blockColor"></i>
                    </div>
                  }
                  @if (timeline?.showToggleIcons) {
                    <div
                      class="close-button me-1"
                      title="{{ 'collapse' | translate }}"
                      [style.border-right-color]="timeline.blockColor"
                      (click)="toggleBlockView(timeline)">
                      <i class="left-icon fa fa-caret-left fa-lg" [style.color]="timeline.blockColor"></i>
                    </div>
                  }
                  <div class="campaign-scroll wrap">
                    @for (milestone of timeline.items; track milestone) {
                      <div
                        class="milestone-item"
                        [ngStyle]="{ opacity: milestone.opacity }"
                        [ngClass]="{ 'disabled-milestone': milestone.activeMilestone == false }"
                        (click)="editMilestone(milestone)">
                        @if (!milestone.items) {
                          <div>
                            <div
                              class="milestone-header px-2"
                              [style.width]="fixedTimelineSize ? `${timelineElementWidth}px` : '120px'"
                              [class.gate-milestone]="gateMilestoneNames.includes(milestone.name)"
                              [style.background]="timeline.blockColor">
                              <div class="pt-1">
                                <span class="timeline-mad-div-text">{{
                                  milestone?.mad === 'MAD' ? 'DUE DATE' : milestone?.mad
                                }}</span>
                              </div>
                              <div class="pb-1">
                                <span class="timeline-mad-div-text">{{
                                  getFormattedDate(milestone.driveDate) | ngbDate
                                }}</span>
                              </div>
                            </div>
                            <div class="col p-0 milestone-body">
                              <div class="d-flex justify-content-end cross-btn-div">
                                @if (milestone.isCross && !editTimelineComponent && !isShow && !isRecap) {
                                  <span
                                    class="badge badge-edit-button"
                                    (click)="$event.stopPropagation(); backToDashboard(milestone)">
                                    <i class="fa fa-times" aria-hidden="true"></i>
                                  </span>
                                }
                              </div>
                              <div
                                class="timeline-name-div here"
                                [style.width]="fixedTimelineSize ? `${timelineElementWidth}px` : '120px'"
                                [ngStyle]="{
                                  background:
                                    milestone.status === 'COMPLETED'
                                      ? '#43CB9A'
                                      : milestone.status === 'IN_PROGRESS' || milestone.status === ''
                                        ? '#FFFF'
                                        : milestone.status === 'DELAYED'
                                          ? '#F67373'
                                          : milestone.status === 'UPCOMING_EXPIRY'
                                            ? '#FB8949'
                                            : '',
                                }">
                                @if (!IsSummary && canEdit) {
                                  <img
                                    [alt]="'calendar'"
                                    ngSrc="/assets/img/project-v2/calendar-black.svg"
                                    width="12"
                                    height="10"
                                    class="calendar-icon" />
                                }
                                <span class="timeline-name-div-text">{{ milestone.name }}</span>
                                <span
                                  class="timeline-mad-div-text mt-auto"
                                  [ngClass]="{ 'handle-black-bg': milestone.status === 'IN_PROGRESS' }">
                                  {{ milestone.actualDate ? (getFormattedDate(milestone.actualDate) | ngbDate) : '' }}
                                </span>
                              </div>
                            </div>
                          </div>
                        } @else {
                          <div class="d-flex">
                            @for (subItem of milestone.items; track subItem) {
                              <div
                                class="col milestone-sub-item"
                                style="width: 120px"
                                [style.background]="timeline.blockColor"
                                (click)="editMilestone(subItem)"
                                [ngClass]="{ 'disabled-milestone': subItem.activeMilestone == false }">
                                <div
                                  class=""
                                  style="position: relative; height: 35px"
                                  [style.background]="timeline.blockColor">
                                  <div class="d-flex justify-content-center">
                                    <span class="d-flex align-item-center _600 f-10 c-full-white">{{
                                      subItem.mad
                                    }}</span>
                                  </div>
                                  <div class="d-flex justify-content-center">
                                    <span class="d-flex align-item-center _600 f-8 c-full-white">{{
                                      getFormattedDate(subItem.driveDate) | ngbDate
                                    }}</span>
                                  </div>
                                </div>
                                <div
                                  class="row milestone-label"
                                  [ngStyle]="{
                                    background:
                                      subItem.status === 'COMPLETED'
                                        ? '#43CB9A'
                                        : subItem.status === 'IN_PROGRESS' || subItem.status === ''
                                          ? '#FFF'
                                          : subItem.status === 'DELAYED'
                                            ? '#F67373'
                                            : subItem.status === 'UPCOMING_EXPIRY'
                                              ? '#FB8949'
                                              : '',
                                  }">
                                  <div
                                    class="col border-right d-flex border-bottom justify-content-center align-items-center p-2"
                                    [ngStyle]="{ background: isDriveCampaign ? subItem.statusColor : '' }"
                                    [style.max-width]="'100%'"
                                    [style.min-width]="'73px'"
                                    [style.height]="'28px'">
                                    <span
                                      class="text-center d-flex align-item-center _600 f-7"
                                      [style.color]="
                                        subItem.status === 'IN_PROGRESS' || subItem.status === '' ? '#000' : '#ffffff'
                                      "
                                      >{{ subItem.name }}</span
                                    >
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                          <div class="d-flex justify-content-end cross-btn-div">
                            @if (milestone.isCross && !editTimelineComponent && !isShow && !isRecap) {
                              <span
                                class="badge badge-edit-button"
                                (click)="$event.stopPropagation(); backToDashboard(milestone)">
                                <i class="fa fa-times" aria-hidden="true"></i>
                              </span>
                            }
                          </div>
                          <div
                            class="col border-right d-flex justify-content-center text-center p-1 pointer-default"
                            [style.height]="'36px'"
                            [style.background]="'#fff'">
                            <div class="d-flex justify-content-center align-items-center">
                              <span class="d-flex align-item-center _600 f-9 c-mtm-full-black">{{
                                milestone.name
                              }}</span>
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }
          <!-- right side button for scroll -->
          <div id="scroll-right-button" [class.disabled]="!fixedTimelineSize && !isRightArrowVisible">
            <div class="scroll-btn scroll-btn-right" (click)="scrollToRight()">
              <img [alt]="'left-triangle'" ngSrc="/assets/img/project-v2/left-triangle-white.svg" alt="" fill="" />
            </div>
          </div>
          <div id="scroll-right-button" [class.disabled]="!fixedTimelineSize && !isRightArrowVisibleForFive">
            <div class="scroll-btn scroll-btn-right-fast-forward" (click)="scrollToRight(425)">
              <img [alt]="'left-triangle'" ngSrc="/assets/img/project-v2/left-triangle-white.svg" alt="" fill="" />
              <img [alt]="'left-triangle'" ngSrc="/assets/img/project-v2/left-triangle-white.svg" alt="" fill="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}

@if (!timelines || !timelines.length) {
  <mtm-timeline-skeleton></mtm-timeline-skeleton>
}

@if (displayMode == TimelineDisplayMode.VerticalList && multiViewsSupport) {
  <mtm-vertical-list-timeline
    [timeline]="timelines"
    [canEdit]="canEdit"
    [isHeaderVisible]="IsDownload"
    (dateClick)="editMilestone($event)"
    [isDownload]="IsDownload"
    [expandable]="!IsDownload"
    [compact]="!IsDownload"></mtm-vertical-list-timeline>
}

@if (displayMode == TimelineDisplayMode.HorizontalMultiLine && multiViewsSupport) {
  <mtm-horizontal-multiline-timeline
    [timeline]="timelines"
    (milestoneClicked)="editMilestone($event)"
    [canEdit]="canEdit">
  </mtm-horizontal-multiline-timeline>
}
